import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

interface Option {
  value: string;
  label: string;
}
interface SelectFieldProps {
  name: string;
  id: string;
  value?: any;
  getOptionLabel?: any;
  options: Option[];
  isMulti?: boolean;
  error?: any;
  dataTestId?: string;
  placeholder?: string;
  required?: boolean;
  errorMessage?: any;
  label?: string;
  onChange?: (option: any, e: any) => void;
  onInputChange?: (option: any, e: any) => void;
  isOptionEqualToValue?: any;
  disabled?: boolean;
  onBlur?: any;
}
export const YSSelectSearch: React.FC<SelectFieldProps> = ({
  name,
  id,
  value,
  options,
  dataTestId,
  required,
  label,
  isOptionEqualToValue,
  disabled,
  getOptionLabel,
  onChange,
  onInputChange,
  errorMessage,
  ...props
}) => {
  return (
    <>
      <FormControl>
        <Autocomplete
          disablePortal
          inputValue={value}
          onInputChange={onInputChange}
          onChange={onChange}
          isOptionEqualToValue={isOptionEqualToValue}
          value={value}
          id={id}
          data-testid={dataTestId}
          options={options}
          {...props}
          renderInput={(params) => <TextField {...params} label={label} />}
        />
        <Typography
          color="error"
          className="error"
          variant="body2"
          component="div"
        >
          {errorMessage}
          {/* <ErrorMessage name={name} /> */}
        </Typography>
      </FormControl>
    </>
  );
};
